// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2ggIS","cell":"ColumnAccessor_cell__1Fl7n","firstCellAccent":"ColumnAccessor_firstCellAccent__1VGXe"};